import { useTranslation } from 'react-i18next';
import SubscriptionOverview from '../components/SubscriptionOverview';
import usePageTitle from '../hooks/usePageTitle';

export default function SubscriptionPage() {
  const { t } = useTranslation(['pages', 'common']);
  usePageTitle(t('pages:subscription.title'));

  return <SubscriptionOverview />;
}
